import McRingChart from './McRingChart';

export default McRingChart;
